// extracted by mini-css-extract-plugin
export var background = "styles-module--background--l-Iqz";
export var cardBodyTestimonial = "styles-module--cardBodyTestimonial--V13pt";
export var cardTestimonial = "styles-module--cardTestimonial--PMqei";
export var colorWhite = "styles-module--colorWhite--n10ST";
export var description = "styles-module--description--SwTlb";
export var itemIcon = "styles-module--itemIcon--Gz5CI";
export var sectionImages = "styles-module--sectionImages--9HFOE";
export var testimonialAvatar = "styles-module--testimonialAvatar--9KyHh";
export var title = "styles-module--title--VVhSM";